import React from 'react';
import { Checkbox } from '../../ui/checkbox';
import { Switch } from '../../ui/switch';
import { format } from 'date-fns';
import { AlertCircle } from 'lucide-react';

const SendLaterSection = ({
  formData,
  handleInputChange,
  errors,
  isDark
}) => {
  return (
    <>
      <div className={`border-none rounded-[16px] p-[20px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)] w-full max-w-[822px] flex flex-col gap-[16px] transition-colors duration-200 ${
        isDark ? 'bg-[#000000]' : 'bg-white'
      } ${formData.send_later && errors.scheduled_time ? 'border-[#FF0000]' : ''}`}>
        {/* Checkbox with label */}
        <div className="flex items-center gap-[8px]">
          <Checkbox
            id="send-later-checkbox"
            checked={formData.send_later || false}
            onCheckedChange={(checked) => {
              handleInputChange('send_later', checked);
            }}
            isDark={isDark}
          />
          <label 
            htmlFor="send-later-checkbox"
            className={`text-[16px] font-semibold cursor-pointer transition-colors duration-200 ${
              isDark ? 'text-white' : 'text-[#072837]'
            }`}
          >
            Send Later
          </label>
        </div>

        {/* Date/Time Picker - Show when checked */}
        {formData.send_later && (
          <>
            <div className={`border-none rounded-[8px] p-[12px] flex items-center gap-[6px] w-full relative transition-colors duration-200 focus-within:border-solid focus-within:border-[1px] focus-within:border-[#CD6D2C] ${
              isDark ? 'bg-[#161515]' : 'bg-[#f5f5f5] border-solid border-[1px] border-[#f8f9fa]'
            }`}>
              <style>{`
                input[type="datetime-local"]::-webkit-calendar-picker-indicator {
                  opacity: 0;
                  position: absolute;
                  right: 0;
                  width: 100%;
                  height: 100%;
                  cursor: pointer;
                }
                input[type="datetime-local"]::-webkit-inner-spin-button,
                input[type="datetime-local"]::-webkit-clear-button {
                  display: none;
                }
              `}</style>
              <input
                type="datetime-local"
                value={formData.scheduled_time ? format(new Date(formData.scheduled_time), "yyyy-MM-dd'T'HH:mm") : ''}
                onChange={(e) => {
                  handleInputChange('scheduled_time', e.target.value);
                }}
                className={`flex-1 bg-transparent border-0 outline-none text-[16px] pr-[32px] transition-colors duration-200 focus:outline-none ${
                  isDark
                    ? 'text-white placeholder:text-[#b3b3b3]'
                    : 'text-[#686868] placeholder:text-[#686868]'
                }`}
              />
              <div
                className="absolute right-[12px] top-1/2 transform -translate-y-1/2 w-[16px] h-[16px] pointer-events-none"
                style={{
                  backgroundColor: isDark ? '#b3b3b3' : '#686868',
                  WebkitMaskImage: "url('/assets/icons/calendar.svg')",
                  WebkitMaskRepeat: 'no-repeat',
                  WebkitMaskSize: 'contain',
                  WebkitMaskPosition: 'center',
                  maskImage: "url('/assets/icons/calendar.svg')",
                  maskRepeat: 'no-repeat',
                  maskSize: 'contain',
                  maskPosition: 'center',
                  transition: 'background-color 0.2s ease'
                }}
                aria-hidden="true"
              />
            </div>

            {/* Notify Submitter Toggle */}
            <div className={`border-none rounded-[8px] p-[12px] flex items-center justify-between w-full transition-colors duration-200 ${
              isDark ? 'bg-[#161515]' : 'bg-[#f5f5f5] border-solid border-[1px] border-[#f8f9fa]'
            }`}>
              <div className="flex gap-[16px] grow items-center">
                <p className={`font-medium text-[16px] grow leading-normal m-0 transition-colors duration-200 ${
                  isDark ? 'text-white' : 'text-[#072837]'
                }`}>
                  Get notified when the scheduled submission is processed
                </p>
                <Switch
                  checked={formData.notify_submitter || false}
                  onCheckedChange={(checked) => handleInputChange('notify_submitter', checked)}
                />
              </div>
            </div>
          </>
        )}
      </div>

      {/* Error message */}
      {formData.send_later && errors.scheduled_time && (
        <div className="w-full max-w-[822px] rounded-[16px] px-[8px] flex items-start gap-[8px] text-[14px] font-semibold text-[#FF0000]">
          <AlertCircle className="h-4 w-4" />
          <span>Please select a date and time for scheduling</span>
        </div>
      )}
    </>
  );
};

export default SendLaterSection;

